export const SEARCH_FORM_SUBMIT = 'STUDENT.HOME.SEARCH_FORM_SUBMIT';
// export const SORT_CHANGE = 'STUDENT.HOME.SORT_CHANGE';
// export const PAGE_CHANGE = 'STUDENT.HOME.PAGE_CHANGE';
export const FETCH_LIST = 'STUDENT.HOME.FETCH_LIST';
